import { render, staticRenderFns } from "./ContractEdit.vue?vue&type=template&id=35a8ae6b&scoped=true"
import script from "./ContractEdit.vue?vue&type=script&lang=js"
export * from "./ContractEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a8ae6b",
  null
  
)

export default component.exports